import IValidationRule from "./ValidationRule";

export default class ValidationRulePhone implements IValidationRule {
  private _message: string | undefined;

  public get message(): string | undefined {
    return this._message;
  }

  public check(value: any): boolean {
    this._message = undefined;

    if (value == null || (value + "").length === 0) {
      return true;
    }

    const regExp = /^\d{2,3}\d{3,4}\d{4}$/;

    if (!regExp.test(value)) {
      this._message = `전화번호가 올바르지 않습니다. 하이픈(-)을 제외한 숫자만 입력하세요.`;

      return false;
    }

    return true;
  }
}
